import React from 'react';
import { useLocation } from 'react-router-dom';

// Boton para ver el juego en el ordenador como en un movil (por ejemplo, para
// ensenar como se juega en una pantalla grande). Abre public/movil.html en la
// misma pantalla en la que se esta. Solo sale en ordenadores (ver index.css) y
// nunca dentro de la propia vista movil.
const VistaMovil = () => {
    const location = useLocation();

    if (window.self !== window.top) {
        return null;
    }

    const ruta = encodeURIComponent(location.pathname + location.search);
    return (
        <a className="vista-movil" href={`/movil.html?ruta=${ruta}`}>Ver como en el móvil</a>
    );
};

export default VistaMovil;
